import { useEffect } from 'react';

export default (eventName, handler) => {
  useEffect(() => {
    // Add the event listener
    window.addEventListener(eventName, handler);

    // Remove the event listener on cleanup
    return () => {
      window.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
}